import React, { useRef, useState } from 'react';
import './game-invite-handler-modal.styles.scss';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useDispatch, useSelector } from 'react-redux';
import { setUserProfile } from '@/state/slices/userSlice';
import Modal, { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { properCase } from '@/utils/properCase';
import { useNavigate } from 'react-router-dom';

const GameInviteHandlerModal = ({
  invite,
  cancel,
  removeApprovedInvite,
  acceptDeclineInvite
}) => {
  
  const screenSize = useSelector(state => state.contentData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const approveRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  

  return (
    <div className={`game-invite-modal ${screenSize}`}>
      <Modal
        show={invite}
        cancel={cancel}
        closeButton={true}
        text='You have been invited to help manage a game'
      >

        {
          (invite) &&
          <div className='invite-modal-content'>
            <div className='g-card org-card'>
              <ImageContainer src={invite.gameIcon} className='org-img' />
              <div className='org-info'>
                <div className='org-title'>{invite.gameName}</div>
                <div className='meta invite-date'>Added {format(new Date(invite.ts_created), "P")}</div>
                <div className='meta'>Role: {properCase(invite.role[0])}</div>
              </div>
            </div>
            <div className="g-space-20"></div>
            <div className='text'>You have been invited to the game <b>"{invite.gameName}"</b>
            <br />as a <b>{properCase(invite.role[0])}</b>!</div>
            <div className="g-space-1"></div>
            <div className='button-row'>
              <button className='g-button' onClick={() => acceptDeclineInvite(invite,false)}>Decline</button>
              <button className='g-button primary' onClick={() => acceptDeclineInvite(invite, true)}>Accept and Get Started</button>
            </div>
          </div>
        }
      </Modal>
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <FullPageLoader
        show={loading} />
    </div>
  )
}

export default GameInviteHandlerModal